import React from 'react';
import { Text, mergeClassNames } from '@clockout-dev/design-elements';
import styles from '../../treasury/elements/styles/pills.module.scss';
import { SUPPORT_TICKET_STATUS } from '../support.enums';
import {
    supportStatusIcons,
    supportStatusLabels,
    supportStatusTones,
} from '../support.constants';

function SupportStatusPill({ status }) {
    const safeStatus = status || SUPPORT_TICKET_STATUS.OPEN;
    const tone =
        supportStatusTones[safeStatus] ||
        supportStatusTones[SUPPORT_TICKET_STATUS.OPEN] ||
        styles.statusSuccess;
    const icon = supportStatusIcons[safeStatus] || supportStatusIcons[SUPPORT_TICKET_STATUS.OPEN];
    const label = supportStatusLabels[safeStatus] || supportStatusLabels[SUPPORT_TICKET_STATUS.OPEN] || safeStatus;

    return (
        <span className={mergeClassNames([styles.pill, tone])}>
            {icon ? (
                <span className={styles.icon} aria-hidden="true">
                    {icon}
                </span>
            ) : null}
            <Text as="span" size="xs" className={styles.label}>
                {label}
            </Text>
        </span>
    );
}

export default SupportStatusPill;
